
import { Inject, Injectable, LOCALE_ID } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve,  } from "@angular/router";
import { Observable } from 'rxjs/internal/Observable';
import { environment } from "src/environments/environment";
import { CanonicalService } from "../services/canonical.service";
import { JsonldService } from "../services/jsonld.service";
import { MetaSeoService } from "../services/meta-seo.service";

@Injectable({
    providedIn: 'root',
  })
  export class CoinsHomeResolver implements Resolve<Object> {
    constructor(
      private canonicalService: CanonicalService,
      @Inject(LOCALE_ID) private localId: Object,
      private seoService:MetaSeoService,
      public jsonldService: JsonldService,
    ){}

    resolve(route: ActivatedRouteSnapshot): Observable<Object> {
      const subSuffex="/crypto"
      const domain = environment.domain;
      const lang = String(this.localId).substring(0, 2);
      const year = new Date().getFullYear();
      let domainAndLangURL = `${domain}/${lang}`;
      let canonicalURL = domainAndLangURL+subSuffex;
      let titlePrefix = `Top Cryptocurrencies ${year} - Explore Trends & Prices `;
      let title = `${titlePrefix} | Halka Arz Info`;
      let description = `Dive into the world of cryptocurrencies with our comprehensive list. Discover latest trends, prices, and market insights on Halka Arz Info.`;
      if(lang == "tr"){
        titlePrefix = `${year}'ün En İyi Kripto Paraları - Fiyatlar & Trendler`;
        title = `${titlePrefix} | Halka Arz Info`;
        description = `Kapsamlı listemizle kripto para dünyasına dalın. Halka Arz Info'da en son trendleri, fiyatları ve pazar analizlerini keşfedin.`;
      }
      this.canonicalService.setCanonicalURLForId(canonicalURL);
      this.seoService.setMetaAndTitle(title,description,canonicalURL,domainAndLangURL,"");
      this.canonicalService.setWrapperAlternate(domain,subSuffex);
      this.jsonldService.removeJsonSnippet();
      this.jsonldService.setOrganization();
      this.jsonldService.setBreadCrumbListItem(domain,lang,title,subSuffex)
      this.jsonldService.setWebSiteType(domain,lang);
      this.jsonldService.setTableType(titlePrefix);
      return null;
    }

}
